const MAP = {
    Target: { bg: "#F3F4F6", text: "#374151", dot: "#9CA3AF" },
    Outreach: { bg: "#EFF6FF", text: "#1D4ED8", dot: "#3B82F6" },
    Connected: { bg: "#EEF2FF", text: "#4338CA", dot: "#6366F1" },
    Active: { bg: "#ECFDF5", text: "#047857", dot: "#10B981" },
    Nurture: { bg: "#FFFBEB", text: "#B45309", dot: "#F59E0B" },
};

export default function StatusBadge({ status, testid }) {
    const s = MAP[status] || MAP.Target;
    return (
        <span
            className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium"
            style={{ backgroundColor: s.bg, color: s.text }}
            data-testid={testid || `status-badge-${status}`}
        >
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.dot }} />
            {status || "—"}
        </span>
    );
}
